module.exports = __webpack_public_path__ + "partylineManage/img/GalleryviewDark.bad37694.png";